<script>
export default {
  name: 'ElementUploadMovie',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleUploadSuccess (res, file) {
      this.item.id = res.id
      this.item.uri = res.uri
    },
    beforeUpload (file) {
      const isMp4 = file.type === 'video/mp4'
      const isLt10MB = file.size < 10 * 1024 * 1024

      if (!isMp4) {
        this.$message.error('mp4フォーマットの動画を登録してください')
        return false
      }
      if (!isLt10MB) {
        this.$message.error('10MB以下のファイルを登録してください')
        return false
      }

      return true
    },
    deleteImage () {
      this.item.id = null
      this.item.uri = null
    }
  },
  watch: {
    'item.uri' (newVal) {
      if (this.$refs.video) {
        this.$refs.video.load()
      }
    }
  }
}
</script>

<template lang="pug">
el-form-item
  el-upload(
    class='c-uploader c-uploader__16_9',
    action='/api/v2/util/uploader',
    name='files',
    :show-file-list="false",
    :on-success='handleUploadSuccess',
    :before-upload='beforeUpload')
    template(v-if='item.uri')
      video.thumb(muted autoplay loop ref="video")
        source(:src='item.uri' type='video/mp4')
    template(v-else)
      .func
        i.icon.el-icon-plus
    .el-upload__tip(slot="tip")
      p mp4 10MB以下
      template(v-if='item.uri')
        i.icon.el-icon-delete(@click='deleteImage')
</template>



// WEBPACK FOOTER //
// src/components/Element/Upload/Movie/index.vue